import Vue from 'vue';
export default {
  data() {
    return {
      searchTitle: '',
      searchModal: false,
      isSearch: false,
      tableHeader: [
        { text: 'تاریخ', value: 'date', align: 'center', isGroupable: true },
        {
          text: 'کد آمبولانس',
          value: 'ambulanceCode',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'کد گوشی',
          value: 'phoneCode',
          align: 'center',
          isGroupable: true,
        },
        { text: 'کاربر', value: 'user', align: 'center', isGroupable: true },
        {
          text: 'کیلومتر سوخت گیری',
          value: 'kilometerRefuel',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'لیتراژ سوخت گیری',
          value: 'literRefuel',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'عنوان جایگاه',
          value: 'stationTitle',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'مسئول جایگاه',
          value: 'stationBoss',
          align: 'center',
          isGroupable: true,
        },
      ],
      tableItems: [],
      searchFromDate: '',
      searchToDate: '',
      searchPhoneId: null,
      searchCityId: null,
      searchVehicleId: null,
      searchUserId: null,
      searchMinimumLiter: null,
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
      technesiansList: [],
    };
  },
  methods: {
    makeDataReady: function (data) {
      this.tableItems = [];
      for (const item of data) {
        let creationDate = '-';
        if (item.creationDate) {
          creationDate = Vue.moment(item.creationDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        let user = `${item?.user?.firstName} ${item?.user?.lastName}`;
        this.tableItems.push({
          date: creationDate,
          ambulanceCode: item.vehicle && item.vehicle.code ? item.vehicle.code : '-',
          phoneCode: item.phone && item.phone.code ? item.phone.code : '-',
          user: user.length > 2 ? user : item?.user?.userName,
          kilometerRefuel: item.kilometer.toString() ? item.kilometer : '-',
          literRefuel: item.liter.toString() ? item.liter : '-',
          stationTitle: item.stationName ? item.stationName : '-',
          stationBoss: item.operatorName ? item.operatorName : '-',
        });
      }
    },
    setPreTimes: function () {
      this.tempSearchFromDate = '00:00:00 ';
      let temp = Vue.moment().format('jYYYY-jMM-jDD');
      this.tempSearchFromDate += temp;
      this.searchFromDate = Vue.moment().format('YYYY-MM-DD');
      this.searchFromDate += 'T00:00:00';
      this.searchToDate = Vue.moment().format('YYYY-MM-DDTHH:mm:ss');
      this.tempSearchToDate = Vue.moment().format('HH:mm:ss jYYYY-jMM-jDD');
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getAmarRefuelReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchPhoneId,
        this.searchVehicleId,
        this.searchUserId,
        this.searchMinimumLiter,
        this.searchCityId,
        this.page,
        this.pageSize,
      );
    },
    removeFilters: function () {
      this.searchPhoneId = null;
      this.searchCityId = null;
      this.searchVehicleId = null;
      this.searchUserId = null;
      this.searchMinimumLiter = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.setPreTimes();
      this.getAmarRefuelReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchPhoneId,
        this.searchVehicleId,
        this.searchUserId,
        this.searchMinimumLiter,
        this.searchCityId,
        this.page,
        this.pageSize,
      );
    },
    cancelSearch: function () {
      this.searchPhoneId = null;
      this.searchCityId = null;
      this.searchVehicleId = null;
      this.searchUserId = null;
      this.searchMinimumLiter = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.searchModal = false;
    },
  },
};
